import axios from "axios";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { createPlatformURL, handleSecureAjaxError, createMutationHeaders } from "../utils/SecurePlatformAPIUtils";
const DEFAULT_WITHDRAWAL_MEANING = "Request for withdrawal failed";

/**
 * Find the experts payment history records
 *
 * @param {function} callback
 */
export const fetchPaymentHistory = callback => {
  const fetchRequestParams = {
    readonly: false,
    requester: "expert"
  };
  axios.get(createPlatformURL("payments/history"), createMutationHeaders(fetchRequestParams)).then(res => {
    const history = [...res.data.history];
    history.map(item => {
      if (item.amount === 0 && item.state === "in_progress") {
        item.amount = res.data.balance;
      }
    });
    callback({
      ...res.data,
      history
    });
  }).catch(error => {
    handleSecureAjaxError(error, "UserPaymentActions FetchPaymentHistory");
    callback({
      hasError: true
    });
  });
};

/**
 * Attempt to process a balance withdrawal request
 *
 * @param {number} balance
 * @param {function} callback
 */
export const processWithdrawal = (balance, callback) => {
  const log = pilog.getLogger("UserPaymentActions requestWithdrawal");
  const fetchRequestParams = {
    readonly: false,
    requester: "expert"
  };
  const paymentObj = {
    amount: balance,
    state: "requested",
    date: new Date()
  };
  axios.put(createPlatformURL("payments/withdraw"), paymentObj, createMutationHeaders(fetchRequestParams)).then(res => {
    log.debug("Withdrawal Platform response, ", res);
    callback(res.data);
  }).catch(error => {
    handleSecureAjaxError(error, "UserPaymentActions requestWithdrawal");
    log.debug(error);
    if (error.response && error.response.data) {
      const errorObject = error.response.data;
      switch (errorObject.code) {
        case "1602":
          errorObject.meaning = "Balance is not yet above minimum amount for withdrawal";
          break;
        case "1603":
          errorObject.meaning = "Withdrawal request can be made once in seven days";
          break;
        case "1604":
          errorObject.meaning = "Unable to request withdrawal, please contact the Expert support team.";
          break;
        default:
          errorObject.meaning = DEFAULT_WITHDRAWAL_MEANING;
          break;
      }
      callback({
        ...errorObject,
        hasError: true
      });
    } else {
      callback({
        hasError: true,
        meaning: DEFAULT_WITHDRAWAL_MEANING
      });
    }
  });
};